export default "__VITE_ASSET__DZaBEAaN__"